import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Tools from './tools';

export default class Animations {
    static init() {
        gsap.registerPlugin(ScrollTrigger);

        const elts = document.querySelectorAll(
            `.article .content__container .text-container h2,
            .article .content__container .text-container h3,
            .article .content__container .text-container h4,
            .article .content__container .text-container h5,
            .article .content__container .text-container h6,
            .article .content__container .text-container p,
            .article .content__container .text-container ul,
            .article .content__container .text-container ol,
            .article .content__container .text-container figure,
            .article .content__container .text-container .wp-block-buttons,
            .article .content__container .text-container .wp-block-media-text__media,
            .article .content__container .text-container .wp-block-media-text__content h2,
            .article .content__container .text-container .wp-block-media-text__content h3,
            .article .content__container .text-container .wp-block-media-text__content h4,
            .article .content__container .text-container .wp-block-media-text__content p,
            .article .content__container .text-container .wp-block-media-text__content ul,
            .article .content__container .text-container .wp-block-media-text__content ol,
            .article .content__container .is-style-chapo p,
            section article form .wrapper fieldset,
            section article form button[type=submit],
            .taxonomy .post__item,
            .blog .post__item,
            .page-template-centre .post__item,
            .home .article .presentation__content p,
            .home .article .presentation__content a,
            .home .article .content__title,
            .header__cta,
            .equipe__title,
            .equipe__cta,
            .equipe__image,
            .avis__title,
            .home .article .avis .tns-nav,
            .wp-google-feedback,
            .wp-google-time,
            .wp-google-name,
            .wp-google-url,
            .content__col,
            .content__cta,
            .content__title,
            .content__text,
            .content__subTitle,
            .single-expertise .article .is-style-chapo p,
            .single-expertise .article .is-style-chapo a,
            .single-expertise .article .is-style-chapo strong,
            .page-template-default .article .is-style-chapo p,
            .page-template-default .article .is-style-chapo a,
            .page-template-default .article .is-style-chapo strong,
            .single-programme .article .is-style-chapo p,
            .single-programme .article .is-style-chapo a,
            .single-programme .article .is-style-chapo strong,
            .article .content .card,
            .article .content .cardImage .cardImage__item,
            .article .content .cardFull,
            .article .content .push,
            .single-post .article .is-style-chapo p,
            .single-post .article .is-style-chapo a,
            .single-post .article .is-style-chapo strong`
        );

        if (elts.length > 0) {
            elts.forEach((elt) => {
                gsap.to(
                    elt,
                    {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%'
                        },
                        ease: "power4.out",
                        duration: 1.25,
                        y: 0,
                        opacity: 1,
                    }
                );
            });
        }

        const eltsStagger = document.querySelectorAll('.taxo__item, .team section .team__container .team__item');

        if (eltsStagger.length > 0) {
            gsap.to(
                eltsStagger,
                {
                    scrollTrigger: {
                        trigger: eltsStagger,
                        start: 'top 80%'
                    },
                    ease: "power4.out",
                    duration: 1.25,
                    y: 0,
                    opacity: 1,
                    stagger: 0.1,
                }
            );
        }
    }
}